import script from "./EditCourseSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditCourseSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./EditCourseSkeleton.vue?vue&type=style&index=0&id=7781df18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7781df18"]])

export default __exports__